var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUptainLogoPublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.436,
    height: 30,
    viewBox: "0 0 84.436 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uptain_Logo_auf_dark_BG",
    "data-name": "uptain_Logo_auf dark BG",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_543",
    "data-name": "Pfad 543",
    d: "M18.725,5.778,13.588,0,8.44,5.778h3.014V16.146c0,2.694-.94,3.87-3.653,3.888s-3.617-1.2-3.617-3.888V6.054C-.392,7.326-.055,11.94.048,15.6c-.416,7.8,8.482,10.53,13.54,5.952C16.88,18.8,15.325,9.6,15.674,5.778ZM32.934,10.9a7,7,0,0,0-7.138-5c-4.184-.09-7.18,1.962-7.289,5.8V30a5.83,5.83,0,0,0,4.166-6.558C31.349,25.464,35.243,18.6,32.934,10.9Zm-4.6,8.436c-1.284,1.482-3.617,1.242-5.637.972v-9c-.3-2.22,5.046-2.532,5.9-.5C29.582,12.27,29.775,18,28.334,19.338Z",
    transform: "translate(0)",
    fill: "#31b9b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_544",
    "data-name": "Pfad 544",
    d: "M61.425,21.871c1.176,2.339,4.1,2.574,6.294,1.809v-2.11c-1.067.47-3.189.524-3.919-.223-1.206-.862-.35-11.352-.6-12.726h4.509V6.588h-4.5V1.65H60.924V6.588H57.91V8.65h3.014c.169,1.935-.458,11.629.5,13.221ZM82.8,21.479c1.242-1.531.6-6.173.754-8.042.283-7.234-6.975-8.271-12.521-6.288V9.325C74.652,8.119,81.663,7.516,81.241,13.2c-3.424-.241-7.62-.494-10.466,1.809a5.217,5.217,0,0,0-.922,5.956c.91,1.935,3.111,2.695,5.022,3.014C77.63,24.246,81.042,23.981,82.8,21.479Zm-6.288.47c-3.219,0-4.931-1.121-4.919-3.388-.506-3.466,6.3-4.039,9.646-3.346.06,3.629.742,6.812-4.726,6.734ZM87.227,6.588h2.285V23.806H87.227ZM87.089.71h2.556V3.266H87.089ZM103.179,8.9a3.521,3.521,0,0,1,2.267,3.647V23.794h2.285c-.416-3.34,1.29-13.595-1.778-15.885-3.014-2.7-8.82-1.676-12.3,0V23.794h2.291V9.277A13.07,13.07,0,0,1,103.179,8.9Z",
    transform: "translate(-23.401 -0.282)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUptainLogoPublic);
export default __webpack_public_path__ + "static/media/uptain_logo_public.8182fb673d65d1daa21ed9b7f7782d0c.svg";
export { ForwardRef as ReactComponent };